import { Card } from '@sravni/react-design-system/lib/Card';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Text, Link } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import { makeMainGEvent, pushEvent } from '../../../../utils/analytics';
import { CITIES } from '../constants/travel';
import styles from '../styles/Travel.module.scss';

export const Travel = () => {
  const isMobile = useIsMobile();

  const handleClick = (e) => {
    const { label: eventLabel } = e.target.dataset;

    pushEvent(
      makeMainGEvent({
        eventCategory: 'Букинг',
        eventAction: 'Сезонные предложения',
        eventLabel,
      }),
    );
  };

  return (
    <Card size={16} variant="secondary" color="blue" className={styles.container}>
      <Space direction="column" size={isMobile ? 12 : 16}>
        <Heading level={4}>
          <Link href="/booking-avia/" data-label="Авиа|Слово" onClick={handleClick}>
            Авиа
          </Link>
          ,{' '}
          <Link href="/booking-rw/" data-label="ЖД Билеты|Слово" onClick={handleClick}>
            жд билеты
          </Link>
          {'\n'}и{' '}
          <Link href="/booking-hotels/" data-label="Отели|Слово" onClick={handleClick}>
            отели
          </Link>{' '}
          без комиссии
        </Heading>
        <Space direction="row" size={12}>
          {CITIES.map(({ city, image }) => (
            <Link key={city} className={styles.link} href="/booking-avia/" data-label="Авиа|Карточка" onClick={handleClick}>
              <Space direction="column" size={4} className={styles.link}>
                <div className={styles.imageWrapper}>
                  <img src={image} className={styles.image} alt={city} />
                </div>
                <Text className={styles.text} size={12}>
                  {city}
                </Text>
              </Space>
            </Link>
          ))}
        </Space>
      </Space>
    </Card>
  );
};
